import {OTLPTraceExporter} from '@opentelemetry/exporter-trace-otlp-http';
import {registerInstrumentations} from '@opentelemetry/instrumentation';
import {DocumentLoadInstrumentation} from '@opentelemetry/instrumentation-document-load';
import {FetchInstrumentation} from '@opentelemetry/instrumentation-fetch';
import {UserInteractionInstrumentation} from '@opentelemetry/instrumentation-user-interaction';
import {XMLHttpRequestInstrumentation} from '@opentelemetry/instrumentation-xml-http-request';
import {Resource} from '@opentelemetry/resources';
import {SimpleSpanProcessor} from '@opentelemetry/sdk-trace-base';
import {WebTracerProvider} from '@opentelemetry/sdk-trace-web';
import {SemanticResourceAttributes} from '@opentelemetry/semantic-conventions';
import config from './config';

const provider = new WebTracerProvider({
  resource: new Resource({
    [SemanticResourceAttributes.SERVICE_NAME]: config.otel.serviceName || '',
    [SemanticResourceAttributes.SERVICE_VERSION]: config.releaseVersion || '',
    [SemanticResourceAttributes.DEPLOYMENT_ENVIRONMENT]: config.env || ''
  })
});

const exporter = new OTLPTraceExporter({
  url: `${config.otel.collectorUrl}/v1/traces`,
  headers: {
    Authorization: `Bearer ${config.otel.bearerToken}`
  }
});

provider.addSpanProcessor(new SimpleSpanProcessor(exporter));
provider.register();

registerInstrumentations({
  instrumentations: [
    new DocumentLoadInstrumentation(),
    new UserInteractionInstrumentation(),
    new FetchInstrumentation(),
    new XMLHttpRequestInstrumentation()
  ]
});
